<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CDivider from '@lib/components/CDivider/CDivider.vue'

const { t } = useI18n()

interface Props {
  showSubmit?: boolean
  disableSubmit?: boolean
  loading?: boolean
  showDivider?: boolean
  submitText?: string
  cancelText?: string
}

withDefaults(defineProps<Props>(), {
  showDivider: true,
  showSubmit: true,
})

const emit = defineEmits<{
  (e: 'submit'): void
  (e: 'cancel'): void
}>()
</script>

<template>
  <div>
    <CDivider v-if="showDivider" />
    <div class="flex justify-end gap-2">
      <CButton @click="emit('cancel')">
        {{ cancelText ? t(cancelText) : t('canvasUI.common.cancel') }}
      </CButton>

      <CButton v-if="showSubmit" :disabled="disableSubmit" :loading="loading" type="primary" @click="emit('submit')">
        {{ submitText ? t(submitText) : t('canvasUI.common.update') }}
      </CButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.n-divider) {
  margin: 8px 0px;
}
</style>
